import Header from "./components/header.js";
import Main from "./components/main.js";
import Footer from "./components/footer.js";
import ChatAgent from "./components/ChatAgent";
import AnalyticsTracker from "./components/AnalyticsTracker";
import { useEffect } from "react";
import { inject } from "@vercel/analytics";
import { ThemeProvider } from "./context/ThemeContext";

export default function App() {
  useEffect(() => {
    // Initialize inject for
    // audience analytics in vercel
    if (process.env.NODE_ENV === 'production') {
      inject();
    }
  }, []);

  return (
    <ThemeProvider>
      <div id="app">
        <Header />
        <Main />
        <Footer />
        <ChatAgent />
        <AnalyticsTracker />
      </div>
    </ThemeProvider>
  );
}
